var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 245.067,
    height: 72.453,
    viewBox: "0 0 245.067 72.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app-store-2",
    "data-name": "app-store"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M225.551,0H19.526c-.751,0-1.492,0-2.241,0-.628,0-1.251.015-1.882.025a30.187,30.187,0,0,0-4.1.32A14.845,14.845,0,0,0,7.407,1.483,13.21,13.21,0,0,0,4.09,3.617,11.466,11.466,0,0,0,1.679,6.554,10.983,10.983,0,0,0,.4,10a21.106,21.106,0,0,0-.366,3.627c-.019.553-.02,1.111-.031,1.667V57.163c.011.562.012,1.106.031,1.669A21.114,21.114,0,0,0,.4,62.459a11.006,11.006,0,0,0,1.282,3.448A11.412,11.412,0,0,0,4.09,68.832a12.868,12.868,0,0,0,3.317,2.134A14.944,14.944,0,0,0,11.3,72.109a31.2,31.2,0,0,0,4.1.32c.632.012,1.254.02,1.882.02.749,0,1.49,0,2.241,0H225.551c.736,0,1.484,0,2.22,0,.623,0,1.264-.007,1.889-.02a30.5,30.5,0,0,0,4.094-.32,15.181,15.181,0,0,0,3.908-1.144,12.847,12.847,0,0,0,3.312-2.134,11.766,11.766,0,0,0,2.42-2.924,10.986,10.986,0,0,0,1.269-3.448,21.438,21.438,0,0,0,.379-3.627c.009-.562.009-1.107.009-1.669.016-.659.016-1.313.016-1.982V17.273c0-.664,0-1.321-.016-1.979,0-.556,0-1.114-.009-1.667A21.431,21.431,0,0,0,244.663,10a11,11,0,0,0-1.269-3.446,12.57,12.57,0,0,0-5.732-5.072A15.175,15.175,0,0,0,233.755.346a30.416,30.416,0,0,0-4.094-.32C229.036.018,228.4.006,227.772,0c-.736,0-1.484,0-2.22,0Z",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M15.533,69.282c-.625,0-1.234-.006-1.855-.018a29.5,29.5,0,0,1-3.835-.3,13.148,13.148,0,0,1-3.4-.992,11.142,11.142,0,0,1-2.865-1.842,9.776,9.776,0,0,1-2.1-2.529,9.531,9.531,0,0,1-1.113-3,19.872,19.872,0,0,1-.342-3.4C.019,56.825,0,55.552,0,55.552V13.711s.019-1.253.031-1.619A19.753,19.753,0,0,1,.371,8.7,9.581,9.581,0,0,1,1.486,5.69,9.851,9.851,0,0,1,3.568,3.157,11.5,11.5,0,0,1,6.444,1.3,13.083,13.083,0,0,1,9.837.32a29.2,29.2,0,0,1,3.847-.3L15.535,0H226.36l1.874.024a28.74,28.74,0,0,1,3.812.294,13.351,13.351,0,0,1,3.429.993,10.9,10.9,0,0,1,4.954,4.383,9.62,9.62,0,0,1,1.1,2.987,20.948,20.948,0,0,1,.356,3.418c.006.514.006,1.064.006,1.612.017.679.017,1.326.017,1.979V53.6c0,.659,0,1.3-.017,1.946,0,.589,0,1.13-.008,1.685a20.407,20.407,0,0,1-.35,3.358,9.551,9.551,0,0,1-1.109,3.026,10.148,10.148,0,0,1-2.082,2.51,11.209,11.209,0,0,1-2.872,1.852,13.154,13.154,0,0,1-3.422,1,29.013,29.013,0,0,1-3.835.3c-.6.012-1.229.018-1.84.018l-2.225,0Z",
    transform: "translate(1.581 1.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": " Group ",
    transform: "translate(18.062 15.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": " Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": " Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": " Path ",
    d: "M26.8,11.46a8.97,8.97,0,0,1,4.269-7.521A9.18,9.18,0,0,0,23.841.033c-3.04-.321-5.99,1.82-7.54,1.82-1.581,0-3.968-1.789-6.536-1.736a9.627,9.627,0,0,0-8.1,4.941c-3.5,6.065-.891,14.978,2.465,19.882,1.679,2.4,3.642,5.081,6.209,4.987,2.512-.1,3.45-1.6,6.483-1.6,3.005,0,3.884,1.6,6.5,1.542,2.7-.045,4.395-2.412,6.014-4.835a19.875,19.875,0,0,0,2.751-5.6A8.661,8.661,0,0,1,26.8,11.46Z",
    transform: "translate(0 9.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": " Path 2",
    d: "M5.881,6.321A8.828,8.828,0,0,0,7.9,0,8.977,8.977,0,0,0,2.088,3,8.4,8.4,0,0,0,.018,9.094,7.424,7.424,0,0,0,5.881,6.321Z",
    transform: "translate(15.974 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(44.297 16.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M14.266,16.412H5.692l-2.06,6.081H0L8.121,0H11.9l8.12,22.493H16.323Zm-7.687-2.8h6.8l-3.35-9.867H9.932Z",
    transform: "translate(0 0.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M15.446,8.373c0,5.1-2.727,8.371-6.843,8.371a5.559,5.559,0,0,1-5.16-2.869H3.366V22H0V.174H3.259V2.9H3.32A5.818,5.818,0,0,1,8.542,0C12.7,0,15.446,3.292,15.446,8.373Zm-3.459,0c0-3.32-1.714-5.5-4.333-5.5-2.571,0-4.3,2.229-4.3,5.5,0,3.305,1.732,5.518,4.3,5.518C10.273,13.892,11.987,11.724,11.987,8.373Z",
    transform: "translate(22.106 6.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M15.449,8.373c0,5.1-2.727,8.371-6.844,8.371a5.559,5.559,0,0,1-5.16-2.869H3.367V22H0V.174H3.259V2.9h.062A5.813,5.813,0,0,1,8.542,0C12.7,0,15.449,3.292,15.449,8.373Zm-3.46,0c0-3.32-1.717-5.5-4.333-5.5-2.573,0-4.3,2.229-4.3,5.5,0,3.305,1.73,5.518,4.3,5.518,2.617,0,4.333-2.167,4.333-5.518Z",
    transform: "translate(40.155 6.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M3.447,16.6c.248,2.23,2.416,3.695,5.377,3.695,2.837,0,4.878-1.465,4.878-3.476,0-1.744-1.231-2.792-4.146-3.508l-2.914-.7C2.51,11.612.593,9.681.593,6.546.593,2.665,3.975,0,8.778,0c4.753,0,8.01,2.665,8.121,6.546H13.5c-.2-2.243-2.059-3.6-4.77-3.6S4.162,4.317,4.162,6.314c0,1.591,1.186,2.524,4.084,3.241l2.479.609c4.615,1.091,6.533,2.947,6.533,6.236,0,4.207-3.353,6.844-8.684,6.844C3.587,23.243.217,20.669,0,16.6Z",
    transform: "translate(64.087 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M5.766,0V3.881H8.885V6.547H5.766v9.04c0,1.405.624,2.06,2,2.06a10.785,10.785,0,0,0,1.108-.079v2.649A9.207,9.207,0,0,1,7,20.375c-3.319,0-4.615-1.248-4.615-4.427v-9.4H0V3.881H2.385V0Z",
    transform: "translate(82.842 2.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M0,8.4C0,3.242,3.039,0,7.779,0s7.779,3.242,7.779,8.4c0,5.175-3.009,8.4-7.779,8.4S0,13.575,0,8.4Zm12.128,0c0-3.539-1.622-5.627-4.349-5.627S3.43,4.878,3.43,8.4c0,3.555,1.62,5.628,4.348,5.628s4.349-2.073,4.349-5.628Z",
    transform: "translate(93.534 6.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M0,.174H3.211V2.965h.078A3.913,3.913,0,0,1,7.234,0,5.182,5.182,0,0,1,8.388.127V3.276a4.721,4.721,0,0,0-1.513-.2A3.389,3.389,0,0,0,3.347,6.325a3.517,3.517,0,0,0,.019.521v9.728H0Z",
    transform: "translate(111.866 6.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M14.791,11.782c-.453,2.977-3.351,5.02-7.061,5.02C2.961,16.8,0,13.606,0,8.479,0,3.334,2.975,0,7.589,0c4.538,0,7.391,3.115,7.391,8.087V9.241H3.4v.2A4.277,4.277,0,0,0,7.808,14.09a3.71,3.71,0,0,0,3.787-2.307ZM3.413,6.89h8.2A3.943,3.943,0,0,0,7.893,2.732c-.1,0-.2-.007-.3,0A4.148,4.148,0,0,0,3.413,6.853Z",
    transform: "translate(120.98 6.268)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": " Group 4",
    transform: "translate(65.178 10.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M0,10.807V0H4.344C6.377,0,7.6,1.034,7.6,2.7A2.369,2.369,0,0,1,5.7,5.018v.126a2.557,2.557,0,0,1,2.434,2.6c0,1.9-1.386,3.061-3.693,3.061Zm1.68-6.23H3.671c1.483,0,2.256-.547,2.256-1.574,0-1-.729-1.58-1.971-1.58H1.68ZM4.106,9.385c1.512,0,2.314-.615,2.314-1.76S5.588,5.9,4.01,5.9H1.68V9.385Z",
    transform: "translate(0 0.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M0,6.007C0,4.538,1.093,3.692,3.035,3.572l2.209-.127v-.7c0-.861-.569-1.349-1.669-1.349-.9,0-1.522.331-1.7.907H.315C.481.9,1.8,0,3.648,0c2.046,0,3.2,1.018,3.2,2.74V8.312H5.3V7.166H5.169A2.742,2.742,0,0,1,2.72,8.447a2.461,2.461,0,0,1-2.705-2.2C.006,6.17,0,6.087,0,6.007Zm5.243-.7V4.628l-1.992.127c-1.123.075-1.632.456-1.632,1.176s.637,1.161,1.512,1.161A1.924,1.924,0,0,0,5.239,5.374Z",
    transform: "translate(9.86 3.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M0,1.1a1.043,1.043,0,1,1,1.1.978l-.061,0A.991.991,0,0,1,0,1.146ZM.241,3.516h1.6v8.156H.241Z",
    transform: "translate(19.015 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M3.572,5.265,1.789,8.156H.023L2.728,4.1,0,0H1.879L3.633,2.876H3.76L5.5,0h1.79L4.6,4.03,7.318,8.156H5.469L3.694,5.265Z",
    transform: "translate(22.811 3.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M0,6.007C0,4.538,1.093,3.692,3.035,3.572l2.208-.127v-.7c0-.861-.569-1.349-1.669-1.349-.9,0-1.522.331-1.7.907H.314C.48.9,1.8,0,3.647,0c2.044,0,3.2,1.018,3.2,2.74V8.312H5.3V7.166H5.17A2.746,2.746,0,0,1,2.72,8.447a2.465,2.465,0,0,1-2.708-2.2C.005,6.17,0,6.087,0,6.007Zm5.243-.7V4.628l-1.991.127C2.13,4.831,1.62,5.211,1.62,5.931s.637,1.161,1.513,1.161A1.921,1.921,0,0,0,5.237,5.374Z",
    transform: "translate(31.549 3.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8477",
    "data-name": "Path 8477",
    d: "M0,.139H1.55V1.39h.119A2.211,2.211,0,0,1,3.872.005,3.34,3.34,0,0,1,4.59.071V1.659a4.509,4.509,0,0,0-.9-.1A1.913,1.913,0,0,0,1.618,3.3a1.453,1.453,0,0,0-.008.183V8.295H0Z",
    transform: "translate(40.915 3.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8478",
    "data-name": "Path 8478",
    d: "M0,.165H1.551v1.3H1.67A2.448,2.448,0,0,1,4.106.008,2.648,2.648,0,0,1,6.928,3.042V8.321H5.318V3.447c0-1.312-.568-1.963-1.758-1.963A1.864,1.864,0,0,0,1.612,3.55V8.321H0Z",
    transform: "translate(51.708 3.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8479",
    "data-name": "Path 8479",
    d: "M0,6.007C0,4.538,1.093,3.692,3.032,3.572l2.21-.127v-.7c0-.861-.571-1.349-1.671-1.349-.9,0-1.52.331-1.7.907H.314C.478.9,1.8,0,3.647,0c2.045,0,3.2,1.018,3.2,2.74V8.312H5.3V7.166H5.169A2.745,2.745,0,0,1,2.717,8.447a2.463,2.463,0,0,1-2.705-2.2A2.314,2.314,0,0,1,0,6.007Zm5.242-.7V4.628l-1.991.127c-1.124.075-1.635.456-1.635,1.176S2.254,7.092,3.13,7.092A1.923,1.923,0,0,0,5.237,5.374Z",
    transform: "translate(60.662 3.36)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.f23e0cccf79355ed78958f19bcbc0001.svg";
export { ForwardRef as ReactComponent };